import { Component, OnInit } from '@angular/core';
import { CommonService, UserService } from '../../_common/_service/user.service';
import { MatCarousel, MatCarouselComponent } from '@ngmodule/material-carousel';
import { TokenStorageService } from '../../_common/_service/token-storage.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
  content?: string;
  interval?: number;
  token: any;
  slides = [{ 'image': 'assets/Images/iripash.png' }];

  constructor(private _service: CommonService, public tokenStorageService: TokenStorageService) {

    this._service.callMethodOfSecondComponent(); // logout


  }

  ngOnInit(): void {
    this.interval = 5;
    //this.userService.getPublicContent().subscribe(
    //  data => {
    //    this.content = data;
    //  },
    //  err => {
    //    this.content = JSON.parse(err.error).message;
    //  }
    //);
  }
}

